import { useThemeContext } from "./ThemeProvider.provider";

export function useTextVariant() {
  const { textVariant } = useThemeContext();
  return textVariant;
}
